import { render, staticRenderFns } from "./facture-patient-bloc.html?vue&type=template&id=cbde271c&external"
import script from "./facture-patient-bloc.js?vue&type=script&lang=js&external"
export * from "./facture-patient-bloc.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports